module.exports = __webpack_public_path__ + "templates/orders.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/orders/templates/orders.html
// module id = o6Yw
// module chunks = 1